import React from 'react';
import {ISelectItem, ISelectProps, SelectInput} from '~/components/Controls/Select';
import {FormField, hasError, IFieldProps, onChangeField} from '~/components/Form';
import {Intent} from '~/lib/intent';
import {useResource} from '~/lib/loader';
import {ID} from '~/lib/model';
import {fetchIntegrationStatuses} from '~/modules/Clients/api';
import { ClientType } from '../models/Seller';

type ISelectClientTypeProps = Omit<ISelectProps<ID>, 'items'>;

const clientTypes: ISelectItem<ClientType>[] = [
    {value: 'T1-enterprise', label: 'T1/enterprise'},
    {value: 'T2', label: 'T2'},
    {value: 'T3', label: 'T3'},
    {value: 'Self-serve', label: 'Self-Serve'},
    {value: 'SSP', label: 'SSP'},
];

export const SelectClientType = ({
    disabled,
    ...props
}: ISelectClientTypeProps) => {
    return <SelectInput {...props} disabled={disabled}
        items={clientTypes}/>;
};

export const SelectClientTypeField = (props: IFieldProps<ISelectClientTypeProps>) => <FormField {...props}>
    <SelectClientType {...props.options}
        intent={hasError(props) && Intent.DANGER}
        value={props.field.value} onChange={value => onChangeField(props, value)}
    />
</FormField>;
